import React, { useContext, useEffect, useRef } from "react"
import { useNavigate, useLocation, useParams } from "react-router"
import { Apis } from "../util/Apis"
import CardWinner from "../components/CardWinner"
import ContainerBackgroundWrapper from "../components/Backgrounds"
import CustomLoading from "../components/CustomLoading"
import Confetti from 'react-confetti'
import useWindowSize from '../hooks/useWindowSize'
import { ContentButtons } from "../components/ButtonCustom";
import NoSorteos from "../components/NoSorteos"
import Text from "../styledComponents/TextStyled"
import axios from "axios";
import { SiteContext } from "../context/SiteContext";
import useGet from "../hooks/useGet"
import Button from "../components/atoms/Buttons"
import RaffleEmptyContent from '../components/virtualRaffle/RaffleEmptyContent';
import { hasRaffleWinner } from '../components/virtualRaffle/raffleResult';
import winnerSound from '../assets/sounds/winner.mp3';
import { isWinnerSoundMuted } from '../util/winnerSound';

const CongratWinner = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const { salaId } = useContext(SiteContext);
  const winnerAudioRef = useRef(null);

  const size = useWindowSize();

  const reveal = location.state?.raffleReveal;
  const hasReveal = reveal?.id === id && (reveal.winner === null || hasRaffleWinner(reveal.winner));
  const { loading, data, error, fetchData } = useGet({
    url: `${Apis.SORTEOS}/sorteos/${id}/winner`,
    initialValue: hasReveal ? reveal.winner : undefined,
    auto: !hasReveal,
  });
  const existWinner = hasRaffleWinner(data);
  const pending = !error && (loading || data === undefined);

  const confirmWinner = () => {
    if (!data?.sorteoWinnerId) {
      navigate('/sorteo-list')
      return
    }

    axios.post(Apis.SORTEOS + '/sorteo-winner/' + data.sorteoWinnerId + '/confirm').finally(() => {
      navigate('/sorteo-list')
    })
  }

  useEffect(() => {
    if (salaId == null || !existWinner || pending || error) return;

    const audio = new Audio(winnerSound);
    winnerAudioRef.current = audio;
    const shouldMuteWinnerSound = isWinnerSoundMuted(salaId);

    if (shouldMuteWinnerSound) {
      winnerAudioRef.current.muted = true;
    } else {
      winnerAudioRef.current.play()?.catch(() => {});
    }

    return () => {
      if (winnerAudioRef.current) {
        winnerAudioRef.current.pause();
        winnerAudioRef.current = null;
      }
    };
  }, [salaId, existWinner, pending, error]);

  return (
    <ContainerBackgroundWrapper showBackgroundCard={false}>
      {error ? <NoSorteos><Text textStyle="small">No se pudo consultar el resultado</Text><ContentButtons><Button onClick={() => fetchData()}>Consultar resultado</Button><Button onClick={() => navigate('/sorteo-list')}>Volver a sorteos</Button></ContentButtons></NoSorteos> : !pending ?
        <>
          {existWinner ?
            <>
              <Confetti
                width={size.width}
                height={size.height}
                opacity={0.8}
              />
              <CardWinner winnerName={[data?.firstName, data?.lastName1].filter(Boolean).join(' ').trim()}
                winnerDocument={data.document}
                winnerDocumentTypeName={data.documentTypeName}
                couponCode={data.couponId}
                machine={data.machine}
                couponCreatedAt={data.couponCreatedAt}
              />

              <ContentButtons style={{ justifyContent: 'space-evenly' }}>
                {data.kind === 'MANUAL' ?
                  <Button onClick={() => navigate(-1)} variant='outline'>REINICIAR</Button>
                  :
                  <Button onClick={() => navigate('/sorteo-animation/' + id)} variant='outline'>REINICIAR</Button>
                }
                <Button onClick={confirmWinner} >CONFIRMAR</Button>
              </ContentButtons>
            </>
            :
            <RaffleEmptyContent
              onRestart={() => navigate('/sorteo-animation/' + id)}
              onBack={() => navigate('/sorteo-list')}
            />
          }
        </>
        :
        <CustomLoading />
      }
    </ContainerBackgroundWrapper>
  )
}

export default CongratWinner;
